import { globalObservability } from '@opendoor/observability/slim';

/**
 * Reports a map failure through the shared observability client, which sends
 * it to Sentry and Datadog. `label` names the failure, as the feature tag did.
 */
export const reportMapError = (label: string, error: unknown, data?: Record<string, string>) =>
  globalObservability.trackError(
    label,
    error instanceof Error ? error : new Error(String(error)),
    data ? { data } : undefined,
  );
